import * as React from "react";
import { useParams } from "react-router-dom";
import UserProfile from "../..";
import { useEffect, useState } from "react";
import { getUser } from "../../../../api/General/account";
import { getCompany } from "../../../../api/General/Company";
import { UserView } from "../../../../models/general";
import Maps from '../../../Attendance/map';
import { useTranslation } from "react-i18next";
import { Skeleton } from "../../../../components/ui/Skeleton";


type Props = Readonly<{
    component?: React.ComponentType<any> | undefined;
    role?: any;
}>;
const AttendanceMap = (props: Props) => {
    const { id } = useParams();
    const { t } = useTranslation();
    const [userInView, setUserInView] = useState<UserView>()
    const [error, setError] = useState<string | null>(null);
    const fetch = async () => {
        try {
            const user = await getUser(id as string);
            if (user.errors?.length > 0) { setError(user.errors[0].message); return; }
            const company = await getCompany(user.payload.company.id);
            setUserInView(user.payload)
        } catch {
            setError(t('Failed to load attendance map'));
        }
    }

    useEffect(() => {
        fetch()
    }, [])

    return (
        <UserProfile >
            {error && <div className="text-center py-8 text-destructive">{error}</div>}
            {id && userInView ? (
                <Maps userInView={userInView} companyId={userInView.company.id} editable userSpecific />
            ) : !error ? (
                <div className="space-y-3" aria-busy="true" aria-live="polite">
                    <Skeleton className="h-6 w-48 rounded" />
                    <Skeleton className="h-[420px] w-full rounded-xl" />
                </div>
            ) : null}
        </UserProfile>
    );
};

export default AttendanceMap as any;
